import React, { useContext } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import LeadsStatusesFetchContext from '@/modules/leads_statuses/contexts/LeadsStatusesFetchContext';

const Component = () => {
    const leadsStatusesFetchContext = useContext(LeadsStatusesFetchContext);
    const data = leadsStatusesFetchContext.data;
    const items = (data) ? data.results : [];

    // noinspection JSValidateTypes,JSUnresolvedVariable
    return (
        <TableBody>
            {items.map((lead_status_fetch) => (
                <TableRow key={lead_status_fetch.id}>
                    {(!lead_status_fetch.error)
                        ? <TableCell className="adv_sub">{lead_status_fetch.adv_sub}</TableCell>
                        : <Tooltip title={lead_status_fetch.error} placement="right" arrow={true}>
                            <TableCell className="adv_sub">
                                <span className="text-error">{lead_status_fetch.adv_sub}</span>
                            </TableCell>
                        </Tooltip>
                    }
                    <TableCell className="role">{lead_status_fetch.role}</TableCell>
                    <TableCell className="city_id">
                        {(!lead_status_fetch.error)
                            ? <>{lead_status_fetch.city_id}</>
                            : null
                        }
                    </TableCell>
                    <TableCell className="city_name">{lead_status_fetch.city_name}</TableCell>
                    <TableCell className="stage">{lead_status_fetch.stage}</TableCell>
                    <TableCell className="last_result">{lead_status_fetch.last_result}</TableCell>
                    <TableCell className="last_reason">{lead_status_fetch.last_reason}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    );
};

export default Component;
